import React from "react";
import { SettingsPageLayout as Layout } from "Containers/Settings/SettingsHub/SettingsPageLayout";
import { lazyLoader } from "Service/loader";
const GeneralSettingsEdit = lazyLoader(
  () =>
    import(
      "Containers/Settings/GeneralSettings/GeneralSettingEdit/GeneralSettingsEdit"
    )
);

export const GeneralSettingsEditLayout = () => {
  return (
    <Layout>
      <GeneralSettingsEdit />
    </Layout>
  );
};
